$mol_ghost $mol_view
	Sub $mol_view
